(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire179d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire179d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ik5Sr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d56ea750786f9579$export$2e2bcd8739ae039);
class $d56ea750786f9579$export$2e2bcd8739ae039 {
    constructor(){
        this.orderTable();
        this.paginationTable();
    }
    orderTable() {
        const ancors = document.querySelectorAll(".order-table");
        const urlParams = new URLSearchParams(window.location.search);
        let sortOrder = urlParams.get("order") || "DESC";
        ancors.forEach((ancor)=>{
            const value = ancor.getAttribute("data-order");
            if (value) ancor.addEventListener("click", ()=>{
                sortOrder = sortOrder === "ASC" ? "DESC" : "ASC";
                this.queryURL([
                    {
                        "key": "orderby",
                        "value": value
                    },
                    {
                        "key": "order",
                        "value": sortOrder
                    }
                ]);
            });
        });
    }
    paginationTable() {
        const ancors = document.querySelectorAll(".pagination");
        ancors.forEach((ancor)=>{
            const value = ancor.getAttribute("data-page");
            if (value) ancor.addEventListener("click", ()=>{
                this.queryURL([
                    {
                        "key": "table-page",
                        "value": value
                    }
                ]);
            });
        });
    }
    queryURL(paramsArray) {
        const urlParams = new URLSearchParams(window.location.search);
        paramsArray.forEach(({ key: key, value: value })=>{
            urlParams.delete(key);
            urlParams.append(key, value);
        });
        window.location.replace(`${location.origin + location.pathname}?${urlParams.toString()}`);
    }
}

});

const $b488569ebaeb416e$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $b488569ebaeb416e$export$2e2bcd8739ae039 = {
    randomUUID: $b488569ebaeb416e$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $d0da4566d2fd20fe$var$getRandomValues;
const $d0da4566d2fd20fe$var$rnds8 = new Uint8Array(16);
function $d0da4566d2fd20fe$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$d0da4566d2fd20fe$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $d0da4566d2fd20fe$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$d0da4566d2fd20fe$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $d0da4566d2fd20fe$var$getRandomValues($d0da4566d2fd20fe$var$rnds8);
}


var $e8c673fd2604883f$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $7d240e1718cbe118$var$validate(uuid) {
    return typeof uuid === "string" && (0, $e8c673fd2604883f$export$2e2bcd8739ae039).test(uuid);
}
var $7d240e1718cbe118$export$2e2bcd8739ae039 = $7d240e1718cbe118$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $8fb7ad22aed8f433$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$8fb7ad22aed8f433$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $8fb7ad22aed8f433$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $8fb7ad22aed8f433$var$byteToHex[arr[offset + 0]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 1]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 2]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 3]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 4]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 5]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 6]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 7]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 8]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 9]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 10]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 11]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 12]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 13]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 14]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 15]];
}
function $8fb7ad22aed8f433$var$stringify(arr, offset = 0) {
    const uuid = $8fb7ad22aed8f433$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $7d240e1718cbe118$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $8fb7ad22aed8f433$export$2e2bcd8739ae039 = $8fb7ad22aed8f433$var$stringify;


function $27d7069422be255c$var$v4(options, buf, offset) {
    if ((0, $b488569ebaeb416e$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $b488569ebaeb416e$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $d0da4566d2fd20fe$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $8fb7ad22aed8f433$export$8fb373d660548968)(rnds);
}
var $27d7069422be255c$export$2e2bcd8739ae039 = $27d7069422be255c$var$v4;



var $ik5Sr = parcelRequire("ik5Sr");
class $31ca146c92a128de$var$Settings {
    constructor(){
        this.addPaymentLink();
        this.editPaymentLink();
        this.copyLink();
        this.handlerToken();
        this.handleModalProducts();
        new (0, $ik5Sr.default)();
    }
    handlerToken() {
        const button = document.querySelector("#generate-token");
        if (button) button.addEventListener("click", ()=>{
            this.generateToken();
        });
    }
    generateToken() {
        const token = document.querySelector("#token");
        if (token) token.value = (0, $27d7069422be255c$export$2e2bcd8739ae039)();
    }
    copyLink() {
        const elements = document.querySelectorAll(".copy-element");
        elements.forEach((element)=>{
            element.addEventListener("click", ()=>{
                const text = element.getAttribute("data-copy");
                if (text) try {
                    navigator.clipboard.writeText(text);
                } catch (error) {
                    const tempTextArea = document.createElement("textarea");
                    tempTextArea.value = text;
                    document.body.appendChild(tempTextArea);
                    tempTextArea.select();
                    document.execCommand("copy");
                    document.body.removeChild(tempTextArea);
                }
            });
        });
    }
    addPaymentLink() {
        const button = document.querySelector("#add-payment-link");
        button.addEventListener("click", ()=>{
            this.openModal();
            this.generateToken();
        });
    }
    editPaymentLink() {
        const anchors = document.querySelectorAll(".open-link-form");
        const close = document.querySelector("#close-link-form");
        anchors.forEach((anchor)=>{
            anchor.addEventListener("click", ()=>{
                this.openModal();
                this.fillModalFields(anchor.getAttribute("data-link"));
            });
        });
        close.addEventListener("click", ()=>{
            this.closeModal();
        });
    }
    openModal() {
        const modal = document.querySelector("#link-form");
        this.clearModal(modal);
        this.clearModalProducts();
        modal.classList.remove("hidden");
    }
    closeModal() {
        const modal = document.querySelector("#link-form");
        this.clearModal(modal);
        this.clearModalProducts();
        modal.classList.add("hidden");
    }
    clearModal(modal) {
        if (!modal) return;
        const fields = [
            "name",
            "token",
            "expire_at",
            "expire_hour",
            "coupon",
            "modal-link-title",
            "hidden_link_id",
            "link_url"
        ];
        fields.forEach((field)=>{
            const element = modal.querySelector(`#${field}`);
            switch(field){
                case "modal-link-title":
                    element.classList.add("hidden");
                    break;
                case "link_url":
                    element.removeAttribute("href");
                    element.classList.add("hidden");
                    break;
                default:
                    if (element) element.value = "";
                    break;
            }
        });
        [
            "product-checkbox",
            "product-number"
        ].forEach((field)=>{
            const elements = modal.querySelectorAll(`.${field}`);
            elements.forEach((element)=>{
                element.value = "";
                if (field === "product-checkbox") element.checked = false;
            });
        });
    }
    fillModalFields(fields) {
        const object = JSON.parse(fields);
        if (object) for(const key in object){
            const element = document.querySelector(`#${key}`);
            switch(key){
                case "products":
                    this.fillModalProducts(object[key]);
                    break;
                case "link_id":
                    element.innerText = `#${object[key]}`;
                    element.parentElement.parentElement.classList.remove("hidden");
                    document.querySelector(`#hidden_${key}`).value = object[key];
                    break;
                case "link_url":
                    element.setAttribute("href", object[key]);
                    element.classList.remove("hidden");
                    break;
                default:
                    if (element) element.value = object[key];
                    break;
            }
        }
    }
    fillModalProducts(products) {
        const productList = document.querySelector("#product-list");
        if (productList) productList.value = JSON.stringify(products);
        products.forEach((product)=>{
            const productsElements = document.querySelectorAll(".modal-product");
            productsElements.forEach((element)=>{
                const checkbox = element.querySelector(".product-checkbox");
                const number = element.querySelector(".product-number");
                if (parseInt(checkbox.getAttribute("data-id")) === product.product) {
                    checkbox.checked = true;
                    number.value = product.quantity;
                }
            });
        });
    }
    clearModalProducts() {
        const productList = document.querySelector("#product-list");
        if (productList) productList.value = "";
    }
    handleModalProducts() {
        const checkboxes = document.querySelectorAll(".product-checkbox");
        const numbers = document.querySelectorAll(".product-number");
        [
            checkboxes,
            numbers
        ].forEach((elements)=>{
            elements.forEach((element)=>{
                element.addEventListener("change", ()=>{
                    this.updateModalProducts();
                });
            });
        });
    }
    updateModalProducts() {
        const products = document.querySelectorAll(".modal-product");
        const list = [];
        products.forEach((product)=>{
            const checkbox = product.querySelector(".product-checkbox");
            const number = product.querySelector(".product-number");
            if (checkbox?.checked) {
                if (!number.value) number.value = 1;
                list.push({
                    product: checkbox.getAttribute("data-id"),
                    quantity: number.value ? number.value : 0
                });
            } else number.value = "";
            checkbox.addEventListener("change", ()=>{
                if (!checkbox.checked) number.value = "";
            });
        });
        const productList = document.querySelector("#product-list");
        if (productList) productList.value = JSON.stringify(list);
    }
}
document.addEventListener("DOMContentLoaded", ()=>{
    new $31ca146c92a128de$var$Settings();
});

})();
//# sourceMappingURL=index.js.map
